import 'stacktable.js/stacktable.js';
/* eslint-disable */
(function($, Drupal, once) {
  'use strict';

  Drupal.behaviors.stacktable = {
    attach: function(context, settings) {

      const stackTableInit = function() {
        $(once('alter-tables', '.responsive-table', context)).each(function(index) {
          // Find all 'repsonsive tables' and add id's
          jQuery(this).attr('id', 'responsive-table-' + index);
          jQuery('#responsive-table-' + index).stacktable();
        });

        $(once('update-tables', '.small-only', context)).each(function(index) {
          // Find all 'repsonsive tables' and add id's
          jQuery(this).attr('id', 'small-only-' + index);
          let $tfoot = jQuery('#responsive-table-' + index + ' tfoot');
          if ($tfoot) {
            $tfoot.clone().appendTo(jQuery('#small-only-' + index));
          }
        });
      };

      stackTableInit();
    }
  };
})(jQuery, Drupal, once);
